import { render, staticRenderFns } from "./LongText.vue?vue&type=template&id=d4c197f6"
import script from "./LongText.vue?vue&type=script&lang=js"
export * from "./LongText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports